import { combineReducers } from "@reduxjs/toolkit";

// Reducers
import authReducer from "../features/auth/authSlice";
import preferencesReducer from "../features/preferences/preferencesSlice";
import setupsReducer from "../features/setups/setupSlices";
import processReducer from "../features/process/processSlices";
import complaintReducer from "../features/complaints/complaintSlice";
import wallReducer from "../features/wall/wallSlices";
import sessionsReducer from "../features/sessions/sessionsSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  setups: setupsReducer,
  preferences: preferencesReducer,
  processes: processReducer,
  complaints: complaintReducer,
  wall: wallReducer,
  sessions: sessionsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
